import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import {FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms'
import 'rxjs/add/operator/switchMap';
import { UtilsService } from '../services/utils.service';

export interface UnsubscribedUserModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-unsubscribed-user-modal',
  templateUrl: './unsubscribed-user-modal.component.html',
  styleUrls: ['./unsubscribed-user-modal.component.css']
})
export class UnsubscribedUserModalComponent extends DialogComponent<UnsubscribedUserModalModel, boolean> implements OnInit {
  title: string;
  data: any;
  currentLang: string;
  agreeToEmailsForm: FormGroup;
  
  constructor(dialogService: DialogService, private fb: FormBuilder, private utilsService: UtilsService) {
    super(dialogService);
  }

  ngOnInit() {
  	this.currentLang = localStorage.getItem('lang') || 'en';
    setTimeout(function () {
            document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
    if (this.data.message) {
        this.data.message = this.utilsService.decodeHtml(this.data.message);
    } else {
        this.data.message = 'There was an unexpected error.'
            + ' Please try again or contact <a href="mailto:support@openlm.com">support@openlm.com</a> if error persists.';
    }
    this.agreeToEmailsForm = this.fb.group({
        'agreeToEmails': [false]
    })
  }
  
  approve() {
    this.result = true;
    this.close();
  }

  cancel() {
      this.result = false;
      this.close();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/unsubscribed-user-modal.component.ts